const stackSplit = stack => stack?.split('\n') || [];
export default stackSplit;
